import { Table } from '@app/modules/table/classes/table.class';
import { AuthService } from '@app/services';
import { Paginator } from '@app/classes';
import { Injectable } from '@angular/core';
import { BenefitInvoice } from '@models/benefits/benefit-invoice.model';
import {
    CreatedAtColumn,
    FilenameColumn,
    ProviderColumn,
    StatusColumn,
} from '@benefits/services/tables/benefit-invoices-table/columns';

@Injectable()
export class BenefitInvoicesTable extends Table {
    links = true;

    constructor(protected auth: AuthService) {
        super(auth);

        this.boot();
    }

    getLink(benefitInvoice: BenefitInvoice): (string | number)[] {
        return ['/benefits', 'settings', 'benefit-invoice', benefitInvoice.id];
    }

    setColumns(): void {
        this.addColumns(new FilenameColumn(), new ProviderColumn(), new CreatedAtColumn(), new StatusColumn());
    }

    setDataSource(): void {
        this.paginator = new Paginator(BenefitInvoice.with(['benefitProvider', 'file']).limit(5), { pageSize: 5 });
    }
}
